import User from './User'

export interface MessageArgument {
  id: string
  user: User
  teamID: string
  message: string
  createdAt?: Date
  replyToId?: string
  activityLogId?: string
}

export default class Message {
  readonly id: string
  readonly user: User
  readonly teamID: string
  readonly message: string
  readonly createdAt: Date
  readonly replyToId?: string
  readonly activityLogId?: string

  constructor(arg: MessageArgument) {
    this.id = arg.id
    this.user = arg.user
    this.teamID = arg.teamID
    this.message = arg.message
    this.createdAt = arg.createdAt ?? new Date()
    this.replyToId = arg.replyToId
    this.activityLogId = arg.activityLogId
  }

  static fromPG(data: any): Message {
    return new Message({
      id: data.id,
      user: User.fromPG(data.users),
      teamID: data.team_id,
      message: data.message,
      createdAt: new Date(data.created_at),
      replyToId: data.reply_to_id,
      activityLogId: data.activity_log_id,
    })
  }

  toPG(): any {
    return {
      id: this.id,
      user_id: this.user.id,
      team_id: this.teamID,
      message: this.message,
      created_at: this.createdAt.toISOString(),
      reply_to_id: this.replyToId,
      activity_log_id: this.activityLogId,
    }
  }
}
